import { ModeleDeBase } from "./ModeleDeBase";
import { INiveauCDS, Niveau } from "./Niveau";
import { IPavillonCDS, Pavillon } from "./Pavillon";

export interface ICasierCDS {
  si_casiersiid: string;
  si_nocasier: string;
  si_ImmeubleSI?: IPavillonCDS;
  si_NiveauSI?: INiveauCDS;
}

export class Casier extends ModeleDeBase {
  numero: string;
  pavillon?: Pavillon;
  niveau?: Niveau;
  verrou?: string;

  constructor(entity: ICasierCDS) {
    super(entity.si_casiersiid);

    this.numero = entity.si_nocasier;

    if (entity.si_ImmeubleSI) {
      this.pavillon = new Pavillon(entity.si_ImmeubleSI);
    }
    if (entity.si_NiveauSI) {
      this.niveau = new Niveau(entity.si_NiveauSI);
    }
  }

  serialiser(): ICasierCDS {
    return {
      si_casiersiid: this.id,
      si_nocasier: this.numero,
    };
  }
}
